import { Card } from '@/components/ui/card';

interface ChartSectionProps {
  children: React.ReactNode;
  title?: string;
}

export function ChartSection({ children, title }: ChartSectionProps) {
  return (
    <Card className="p-4">
      {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
      {children}
    </Card>
  );
}
